/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EducationConstraintSchemaMode = typeof EducationConstraintSchemaMode[keyof typeof EducationConstraintSchemaMode];


export const EducationConstraintSchemaMode = {
  include: 'include',
  exclude: 'exclude',
} as const;
